import type { CommentListOrder } from '@/@types/comment'
import { css } from '@emotion/react'
import CommentList, { type CommentListProps } from '../Comment/CommentList'
import CommentListOrderSelect from '../Comment/CommentListOrderSelect'

export interface CommentListSectionProps extends CommentListProps {
	order: CommentListOrder
	onOrderChange?: (next: CommentListOrder) => void
}

export default function CommentListSection({
	data = [],
	order,
	onOrderChange,
	isLoading = false,
	...props
}: CommentListSectionProps) {
	return (
		<section
			css={css`
				display: grid;
				grid-template-rows: auto 1fr;
				overflow: hidden;
			`}
			{...props}
		>
			<header
				css={css`
					display: flex;
					justify-content: space-between;
					place-items: center;
					padding: 10px 15px;
					color: var(--tint-secondary);
					font-size: 14px;
					line-height: 20px;
					box-shadow: 0 0.5px 0 0 var(--tint-separator);
				`}
			>
				<span>全部评论</span>
				<CommentListOrderSelect value={order} onChange={onOrderChange} />
			</header>

			<CommentList isLoading={isLoading} data={data} />
		</section>
	)
}
